// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('customer.external', {
    url: '/external',
    templateUrl: 'main/customer/external/external.tpl.html',
    controller: 'CustomerExternalUsersController as vm',
  });
};

class CustomerExternalUsersController {
  constructor($rootScope, customer) {
    'ngInject';
    $rootScope.pageTitle = `${customer.name || ''} - External`;

    this.customer = customer;
  }
}

angular
  .module('main.customer.external', [])
  .config(config)
  .controller(
    'CustomerExternalUsersController',
    CustomerExternalUsersController,
  );
